import { render, staticRenderFns } from "./agreement_nullified_show.vue?vue&type=template&id=47481aba"
import script from "./agreement_nullified_show.vue?vue&type=script&lang=js"
export * from "./agreement_nullified_show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports